import styled from "styled-components";

export const EmployeeScheduleStyles = styled.section`
  min-height: calc(100vh - 42px);
`;
